import { useEffect, FC, memo, useState, ComponentType } from 'react';
import mitt, { Emitter } from 'mitt';

import { getLocalizationCountryCookie } from '@app/helpers/localization';

const LOGIN_APP_ID_CONTAINER = 'accountLinkContainer';
const LOCALIZATION_COUNTRY_SET_EVENT = 'localization-country-set';

declare global {
  interface Window {
    emitter?: Emitter;
  }
}

const AccountWidget: FC = () => {
  const [
    LoginAppComponent,
    setLoginAppComponent,
  ] = useState<ComponentType | null>(null);

  useEffect(() => {
    const initialCountry = getLocalizationCountryCookie();

    const handleCountryCookieSet = () => {
      if (initialCountry !== getLocalizationCountryCookie()) {
        window.location.reload();
      }
    };

    // Needed for nicom-login message passing
    window.emitter ??= mitt();

    import(/* webpackChunkName: "login" */ 'login/app/AppComponent').then(
      (result) => {
        // see nicom-login emitterEvents
        window.emitter?.on(
          LOCALIZATION_COUNTRY_SET_EVENT,
          handleCountryCookieSet
        );

        setLoginAppComponent(result.default);
      }
    );

    () => {
      window.emitter?.off(
        LOCALIZATION_COUNTRY_SET_EVENT,
        handleCountryCookieSet
      );
    };
  }, []);

  return (
    <div id={LOGIN_APP_ID_CONTAINER}>
      {LoginAppComponent ? <LoginAppComponent /> : null}
    </div>
  );
};

export default memo(AccountWidget);
